// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: admin/payload/AdminAuthPayloadPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ApiResultPayload } from "../../common/model/ApiResultCodePt";
import { AdminPayload } from "../model/AdminPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.admin.payload";

export interface AdminLoginRequestPayload {
  /** 로그인 아이디 */
  loginId: string;
  /** 비밀번호 */
  password: string;
}

/**
 * 로그인 응답
 *
 * 실패 사유는 구분하지 않는다 — 아이디 열거를 막으려고 result 에 같은 문구만 담는다.
 */
export interface AdminLoginResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 액세스 토큰 (이후 요청의 Authorization: Bearer 에 싣는다) */
  accessToken: string;
  /** 토큰 만료까지 남은 초 */
  expiresInSeconds: number;
  /** 로그인한 관리자 */
  admin: AdminPayload | undefined;
}

export interface AdminGetMeResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 토큰이 가리키는 관리자 */
  admin: AdminPayload | undefined;
}

export interface AdminChangePasswordRequestPayload {
  /** 현재 비밀번호 */
  currentPassword: string;
  /** 새 비밀번호 */
  newPassword: string;
}

function createBaseAdminLoginRequestPayload(): AdminLoginRequestPayload {
  return { loginId: "", password: "" };
}

export const AdminLoginRequestPayload: MessageFns<AdminLoginRequestPayload> = {
  encode(message: AdminLoginRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.loginId !== "") {
      writer.uint32(10).string(message.loginId);
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminLoginRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminLoginRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.loginId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.password = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminLoginRequestPayload {
    return {
      loginId: isSet(object.loginId) ? globalThis.String(object.loginId) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: AdminLoginRequestPayload): unknown {
    const obj: any = {};
    if (message.loginId !== "") {
      obj.loginId = message.loginId;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminLoginRequestPayload>, I>>(base?: I): AdminLoginRequestPayload {
    return AdminLoginRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminLoginRequestPayload>, I>>(object: I): AdminLoginRequestPayload {
    const message = createBaseAdminLoginRequestPayload();
    message.loginId = object.loginId ?? "";
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseAdminLoginResponsePayload(): AdminLoginResponsePayload {
  return { result: undefined, accessToken: "", expiresInSeconds: 0, admin: undefined };
}

export const AdminLoginResponsePayload: MessageFns<AdminLoginResponsePayload> = {
  encode(message: AdminLoginResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.accessToken !== "") {
      writer.uint32(18).string(message.accessToken);
    }
    if (message.expiresInSeconds !== 0) {
      writer.uint32(24).int32(message.expiresInSeconds);
    }
    if (message.admin !== undefined) {
      AdminPayload.encode(message.admin, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminLoginResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminLoginResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.accessToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.expiresInSeconds = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.admin = AdminPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminLoginResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      accessToken: isSet(object.accessToken) ? globalThis.String(object.accessToken) : "",
      expiresInSeconds: isSet(object.expiresInSeconds) ? globalThis.Number(object.expiresInSeconds) : 0,
      admin: isSet(object.admin) ? AdminPayload.fromJSON(object.admin) : undefined,
    };
  },

  toJSON(message: AdminLoginResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.accessToken !== "") {
      obj.accessToken = message.accessToken;
    }
    if (message.expiresInSeconds !== 0) {
      obj.expiresInSeconds = Math.round(message.expiresInSeconds);
    }
    if (message.admin !== undefined) {
      obj.admin = AdminPayload.toJSON(message.admin);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminLoginResponsePayload>, I>>(base?: I): AdminLoginResponsePayload {
    return AdminLoginResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminLoginResponsePayload>, I>>(object: I): AdminLoginResponsePayload {
    const message = createBaseAdminLoginResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.accessToken = object.accessToken ?? "";
    message.expiresInSeconds = object.expiresInSeconds ?? 0;
    message.admin = (object.admin !== undefined && object.admin !== null)
      ? AdminPayload.fromPartial(object.admin)
      : undefined;
    return message;
  },
};

function createBaseAdminGetMeResponsePayload(): AdminGetMeResponsePayload {
  return { result: undefined, admin: undefined };
}

export const AdminGetMeResponsePayload: MessageFns<AdminGetMeResponsePayload> = {
  encode(message: AdminGetMeResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.admin !== undefined) {
      AdminPayload.encode(message.admin, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGetMeResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGetMeResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.admin = AdminPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGetMeResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      admin: isSet(object.admin) ? AdminPayload.fromJSON(object.admin) : undefined,
    };
  },

  toJSON(message: AdminGetMeResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.admin !== undefined) {
      obj.admin = AdminPayload.toJSON(message.admin);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGetMeResponsePayload>, I>>(base?: I): AdminGetMeResponsePayload {
    return AdminGetMeResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGetMeResponsePayload>, I>>(object: I): AdminGetMeResponsePayload {
    const message = createBaseAdminGetMeResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.admin = (object.admin !== undefined && object.admin !== null)
      ? AdminPayload.fromPartial(object.admin)
      : undefined;
    return message;
  },
};

function createBaseAdminChangePasswordRequestPayload(): AdminChangePasswordRequestPayload {
  return { currentPassword: "", newPassword: "" };
}

export const AdminChangePasswordRequestPayload: MessageFns<AdminChangePasswordRequestPayload> = {
  encode(message: AdminChangePasswordRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.currentPassword !== "") {
      writer.uint32(10).string(message.currentPassword);
    }
    if (message.newPassword !== "") {
      writer.uint32(18).string(message.newPassword);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminChangePasswordRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminChangePasswordRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.currentPassword = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.newPassword = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminChangePasswordRequestPayload {
    return {
      currentPassword: isSet(object.currentPassword) ? globalThis.String(object.currentPassword) : "",
      newPassword: isSet(object.newPassword) ? globalThis.String(object.newPassword) : "",
    };
  },

  toJSON(message: AdminChangePasswordRequestPayload): unknown {
    const obj: any = {};
    if (message.currentPassword !== "") {
      obj.currentPassword = message.currentPassword;
    }
    if (message.newPassword !== "") {
      obj.newPassword = message.newPassword;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminChangePasswordRequestPayload>, I>>(
    base?: I,
  ): AdminChangePasswordRequestPayload {
    return AdminChangePasswordRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminChangePasswordRequestPayload>, I>>(
    object: I,
  ): AdminChangePasswordRequestPayload {
    const message = createBaseAdminChangePasswordRequestPayload();
    message.currentPassword = object.currentPassword ?? "";
    message.newPassword = object.newPassword ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
